// eslint-disable-next-line import/prefer-default-export
export const getDisqusAccessToken = () => {
  return {
    types: [
      'GET_DISQUS_ACCESS_TOKEN_REQUEST',
      'GET_DISQUS_ACCESS_TOKEN_SUCCESS',
      'GET_DISQUS_ACCESS_TOKEN_FAILURE',
    ],
    config: {
      url: 'profile/users/disqus_sso/',
    },
  };
};
